import { ChainIds } from "@armana/walletconnect-koinos-sdk-js";
import { TOKENS_BASE } from "./tokens";
const APP_CHAIN = import.meta.env.VITE_CHAIN;

let config = {
  ["MAINNET"]: {
    // block explorers the user can pick in the settings; the first one is the default
    explorer: [
      {
        id: "koinosblocks",
        name: "Koinosblocks",
        tx: "https://koinosblocks.com/tx",
        address: "https://koinosblocks.com/address",
        block: "https://koinosblocks.com/block",
      },
      {
        id: "koinscan",
        name: "KoinScan",
        tx: "https://www.koinscan.com/tx",
        address: "https://www.koinscan.com/address",
        block: "https://www.koinscan.com/blocks",
      },
      {
        id: "koinosscan",
        name: "KoinosScan",
        tx: "https://koinosscan.com/tx",
        address: "https://koinosscan.com/address",
        block: "https://koinosscan.com/block",
      },
    ],
    api: {
      url: import.meta.env.VITE_BACKEND_API_URL,
      key: import.meta.env.VITE_BACKEND_API_KEY,
    },
    chain: {
      name: "Mainnet",
      id: "EiBZK_GGVP0H_fXVAM3j6EAuz3-B-l3ejxRSewi7qIBfSA==",
      nameservice: ["koin", "vhp"],
      contracts: {
        nameservice: "19WxDJ9Kcvx4VqQFkpwVmwVEy1hMuwXtQE",
      },
    },
    contracts: {
      ido: {
        address: "",
        launched: false,
      },
      koindx: {
        address: "",
        launched: false,
      },
      skoindx: {
        address: "",
        launched: false,
      },
      governance: {
        address: "",
        launched: false,
      },
      periphery: {
        address: "17e1q6Fh5RgnuA8K7v4KvXXH4k9qHgsT5s",
        launched: true,
      },
      // KOINDX token, its balance is shown in the account drawer
      koindx_token: {
        address: "1DdERbxQte8XCwLQT8KVDyq1NJo5EGhpdg",
      },
    },
    tokens: {
      ...TOKENS_BASE,
    },
    wallet: {
      walletconnect_network_id: ChainIds.Mainnet,
      mkw_connector_url: "https://mykw.vercel.app/embed/wallet-connector",
    },
  },
  ["HARBINGER"]: {
    explorer: [
      {
        id: "koinosblocks",
        name: "Koinosblocks",
        tx: "https://harbinger.koinosblocks.com/tx",
        address: "https://harbinger.koinosblocks.com/address",
        block: "https://harbinger.koinosblocks.com/block",
      },
    ],
    api: {
      url: import.meta.env.VITE_BACKEND_API_URL,
      key: import.meta.env.VITE_BACKEND_API_KEY,
    },
    chain: {
      name: "Harbinger",
      id: "EiBncD4pKRIQWco_WRqo5Q-xnXR7JuO3PtZv983mKdKHSQ==",
      nameservice: ["koin", "vhp"],
      contracts: {
        nameservice: "13NQnca5chwpKm4ebHbvgvJmXrsSCTayDJ",
      },
    },
    contracts: {
      ido: {
        address: "",
        launched: false,
      },
      koindx: {
        address: "",
        launched: false,
      },
      skoindx: {
        address: "",
        launched: false,
      },
      periphery: {
        address: "18MV8beHrgV78JpHxTXrvPfSmP2kWy7DVk",
        launched: true,
      },
      koindx_token: {
        address: "",
      },
    },
    tokens: {
      ...TOKENS_BASE,
    },
    wallet: {
      //walletconnect_network_id: "koinos:EiBncD4pKRIQWco_WRqo5Q-xnXR7JuO3PtZv983mKdKHSQ=="
      walletconnect_network_id: ChainIds.Harbinger,
      mkw_connector_url: "https://mykw.vercel.app/embed/wallet-connector",
    },
  },
};

export const CONFIG_BASE = config[APP_CHAIN];
